//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            warnings: {
                "past_residents": [],
                "duplicate_transactions": [],
                "credit_rents": [],
                "missing_rents": []
            },
            transactions: [],
            start_date: moment().format('YYYY-MM-02'),
            end_date: moment().add(1, 'M').format('YYYY-MM-01'),
            loading: true,
            preview: true,
            status: 'Processing',
            job: false,
            processing: false,
            confirm: false,
            lastJob: false,
            validJob: true,
            runDate: '',
            total: 0,
            totalCount: 0
        };
    },
    mounted: function mounted() {
        Event.$on('add-ar-billing', this.load);
    },

    methods: {
        load: function load() {
            var _this = this;

            Object.assign(this.$data, this.$options.data());
            var $el = this;
            var data = { start: $el.start_date, end: $el.end_date };

            $el.$children[0].$data.showModal = true;

            axios.get('/prototype/accounting/accounts-receivable/billings/last', data).then(function (response) {
                $el.lastJob = response.data.job;
                $el.runDate = response.data.runDate;

                var validCheck = false;

                if (!$el.lastJob || $el.lastJob.created_at && moment($el.lastJob.created_at).month() !== moment().month()) {
                    validCheck = true;
                }

                if (validCheck) {
                    axios.post('/prototype/accounting/accounts-receivable/billings/start', data).then(function (response) {

                        // groupby function
                        var groupBy = function groupBy(array, key) {
                            return array.reduce(function (result, currentValue) {
                                (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
                                return result;
                            }, {});
                        };

                        // set total count of transactions returned
                        $el.totalCount = response.data.length;

                        // calculate total of all transactions returned
                        response.data.map(function (transaction) {
                            transaction.charge_type == 'Credit' ? $el.total -= parseFloat(transaction.true_amount) : $el.total += parseFloat(transaction.true_amount);
                        });

                        $el.transactions = groupBy(response.data, 'unit_name');
                        /*
                        $el.transactions = response.data.sort((a,b)=>{
                            let sortA = a[0].ledger.resident.unit ? a[0].ledger.resident.unit.unit_label : null;
                            let sortB = b[0].ledger.resident.unit ? b[0].ledger.resident.unit.unit_label : null;
                            return sortA - sortB;
                        });
                        */
                        _this.loading = false;
                    });

                    axios.get('/prototype/accounting/accounts-receivable/billings/pre-bill-warnings', data).then(function (response) {
                        $el.warnings = response.data;
                    });
                } else {
                    $el.validJob = false;
                    _this.loading = false;
                }
            });
        },
        process: function process() {

            var $el = this;

            $el.loading = true;
            $el.processing = true;

            axios.post('/prototype/accounting/accounts-receivable/billings/process').then(function (response) {

                $el.job = response.data;
                $el.status = 'Complete';
                $el.loading = false;
                $el.processing = false;
                $el.$children[0].$data.showModal = false;

                setTimeout(Event.$emit('refresh-billing-list'), 2000);
            });
        },
        showPreview: function showPreview() {
            this.preview = true;
        },
        unitTotal: function unitTotal(unitIdx) {
            var total = 0;
            this.transactions[unitIdx].map(function (transaction) {
                transaction.charge_type == 'Credit' ? total -= parseFloat(transaction.true_amount) : total += parseFloat(transaction.true_amount);
            });
            return total;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-receivable/billings/ArAddBilling.vue
// module id = rAXL
// module chunks = 0 1